import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { MyListingSourceRenderImplemented, ReviewSources, SourceSelectionModalData } from '../types';
import { arrayContentEqual } from '@vendasta/rx-utils';
import { ReviewSourceSelectionService } from '../source-selection.service';
import { SourceSelectionPanelComponent } from '../source-selection-panel/source-selection-panel.component';

@Component({
  selector: 'reviews-source-selection-modal',
  imports: [CommonModule, MatDialogModule, TranslateModule, SourceSelectionPanelComponent],
  templateUrl: './source-selection-modal.component.html',
  styleUrls: [
    './source-selection-modal.component.scss',
    '../source-selection-panel/source-selection-panel.component.scss',
    '../source-selection-shared-styles.scss', //placeholding until extracting needed styles
  ],
})
export class SourceSelectionModalComponent {
  filteredReviewSources$: Observable<ReviewSources>;

  protected dialogRef = inject(MatDialogRef<SourceSelectionModalComponent>);
  public data: SourceSelectionModalData = inject(MAT_DIALOG_DATA);
  public preselectedIDs$$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(this.data.preselectedSources);
  public preselectedIDs$: Observable<string[]> = this.preselectedIDs$$.asObservable();
  public selectableIDs: string[] = [];

  reviewSources$: Observable<ReviewSources>;
  maxSelections = Infinity;

  constructor(private sourceSelectionService: ReviewSourceSelectionService) {
    this.reviewSources$ = this.sourceSelectionService.reviewSourcesWithURLs$.pipe(
      map((sources: ReviewSources) => {
        const reviewSources = {
          ...sources,
          primarySourceIds: !MyListingSourceRenderImplemented
            ? sources.primarySourceIds.filter((id) => id !== '12000')
            : sources.primarySourceIds,
        };

        if (this.data.idsOverrideForSelection.length === 0) {
          return reviewSources;
        } else {
          return {
            ...reviewSources,
            primarySourceIds: reviewSources.primarySourceIds.filter((id) => {
              return this.data.idsOverrideForSelection.includes(id);
            }),
            otherSourceIds: reviewSources.otherSourceIds.filter((id) => {
              return this.data.idsOverrideForSelection.includes(id);
            }),
          };
        }
      }),
    );

    if (this.preselectedIDs$$) {
      this.preselectedIDs$$.next(this.data.preselectedSources);
    }
  }

  requestSourceIdsSelected(sourceIds: string[]): void {
    if (sourceIds !== null) {
      if (!arrayContentEqual(sourceIds, this.data.preselectedSources)) {
        this.data.preselectedSources = sourceIds;
      }
      this.dialogRef.close(this.data.preselectedSources);
    }
  }
}
